
    export class SelectCondition {
        id: string;
        version: number;
        condition: string;
        value: string;
    }

    export class AssociationField {
        masterField: string;
        detailField: string;
    }

    export class Object {
        id: string;
        version: number;
        type: string;
        name: string;
        selectConditions: SelectCondition[] | any[];
        associationFields: AssociationField[];
    }

    export class FieldMapping {
        id: string;
        version: number;
        key: boolean;
        serverFieldName: string;
        clientFieldName: string;
        ignore: string;
    }

    export class SyncItem {
        id: string;
        version: number;
        objects: Object[];
        clientSpecific: boolean;
        fieldMappings: FieldMapping[] | any[];
        associatedItems: SyncItem[];
    }

    export class ConfigurationItem {
        id: string;
        version: number;
        type: string;
        syncItems: SyncItem[];
    }

    export class DataSyncConfiguration {
        id: string;
        version: number;
        companyId: string;
        active: boolean;
        recordsPerDataPatch: number;
        dataPatchesPerRequest: number;
        configurationItems: ConfigurationItem[];
    }

    export enum DataSyncObjectType {
        SERVER, CLIENT
    }

    export enum DataSyncSelectionConditionEnum {
        INITIAL, SELECT, UPDATE, DELETE, DELETE_ALL
    }

    export enum DataSyncConfigurationItemType {
        PULL /* from Server to Client */, PUSH /*from Client to Server*/, TWOWAY
    }

    export enum DataSyncFieldMappingIgnore {
        NONE, SERVER, CLIENT
    }
    
    
    
